import {
  IconButton,
  Dialog,
  DialogContent,
  Snackbar,
  Alert,
  Typography,
  TextField,
  Button,
  Box,
} from "@mui/material";
import XIcon from "@mui/icons-material/X";
import { Share, ContentCopy, Send, Facebook, FacebookRounded } from "@mui/icons-material";
import { useState } from "react";
import {
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
} from "react-icons/fa";

import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
} from "react-share";

function ShareButton({ name, url }) {
  const [dialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Snackbar open state
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const shareToPlatform = (platform) => {
    const message = `Check out this content: ${name}\n${url}`;
    const encodedMessage = encodeURIComponent(message);
    
    let shareUrl = "";
  
    switch (platform) {
      case "whatsapp":
        shareUrl = `https://wa.me/?text=${encodedMessage}`;
        break;
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent('https://test.wiseofficeday.com/AssessmentPreview/131')}`;
        break;
      case "instagram":
        navigator.clipboard.writeText(message);
        setSnackbarMessage(
          "Instagram does not support direct sharing of links. The link has been copied to your clipboard. Paste it into your Instagram bio or share it manually."
        );
        setSnackbarOpen(true);
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?text=${encodedMessage}`;
        break;
        case "linkedin":
          shareUrl = `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(name)}&summary=${encodeURIComponent("Check out this amazing content!")}&source=example.com`;
          break;
       default:
        break;
    }
  
    if (shareUrl) {
      window.open(shareUrl, "_blank");
    }
  
    handleDialogClose();
  };
  

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    setSnackbarMessage("Link copied to clipboard!");
    setSnackbarOpen(true);
  };

  return (
    <div className="relative mt-1">
     

      <button
        onClick={handleDialogOpen}
        className="text-sm lss-buttons  bg-gray-100"
      >
        <span>
          <Send fontSize="small" />
        </span>
        <span className="ml-1">Share</span>
      </button>
      <Dialog open={dialogOpen} onClose={handleDialogClose}>
        <DialogContent
          sx={{
            width: "550px", // Adjust the width of the popup
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Typography Wrapper */}
          <Box
            sx={{
              backgroundColor: "#1976d2",
              color: "white",
              padding: "8px",
              marginBottom: "16px",
              marginLeft: "-24px",
              width: "550px",
              marginTop: "-20px",
            }}
          >
            <Typography variant="h6">Share this Content</Typography>
          </Box>

          <div className="flex justify-center space-x-6 mb-4">
            <IconButton
              onClick={() => shareToPlatform("whatsapp")}
              title="Share on WhatsApp"
            >
              <FaWhatsapp size="2rem" className="text-green-600" />
            </IconButton>

            <IconButton
              url={url}
              quote={`Take a look at this amazing content: ${name}`}
              title="Share on Facebook"
              onClick={() => shareToPlatform("facebook")}
            >  <FaFacebookF  size='2rem' className="text-blue-700"/>
            </IconButton>
            <IconButton
              onClick={() => shareToPlatform("twitter")}
              title="Share on Twitter"
            >
              <FaTwitter size="2rem" className="text-blue-400" />
            </IconButton>
            <IconButton
              onClick={() => shareToPlatform("linkedin")}
              url={url}
              quote={`Take a look at this amazing content: ${name}`}
              title="Share on LinkedIn"

            >
              <LinkedinIcon size={36} round={true} />
            </IconButton>
          </div>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: "100%",
            }}
          >
            <TextField
              value={url}
              InputProps={{
                readOnly: true,
              }}
              fullWidth
              variant="outlined"
            />
            <Button
              variant="contained"
              startIcon={<ContentCopy />}
              onClick={handleCopyLink}
              sx={{
                backgroundColor: "#1976d2",
                color: "white",
                whiteSpace: "nowrap",
              }}
            >
              Copy Link
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default ShareButton;
